<template>
  <PageContainer>
    <div class="flex flex-col flex-wrap content-center">
      <div class="px-8">
        <h2><span class="font-bold">{{ userStore.user.name }}</span>, what is your main sleep goal?</h2>
        <p>We'll use this to personalise your coaching experience 🤗</p>
      </div>
      <div class="grid grid-cols-1 gap-4 mt-4">
        <div v-for="g in goals" :key="g" @click="selectGoal(g.key)" class="text-left p-4 rounded-lg bg-gray-50 cursor-pointer" :class="{ 'border-2 border-teal-200': g.selected }">
          <input type="checkbox" :name="g.key" class="hidden">
          <label :for="g.key">{{ g.name }}</label>
        </div>
      </div>
      <button @click="goToNext()" :disabled="!hasSelectedGoal">Next →</button>
    </div>
  </PageContainer>
</template>

<script>
import PageContainer from '@/components/PageContainer'
import Goal from '@/models/goal'
import { mapStores } from 'pinia'
import { useUserStore } from '@/stores/user'

export default {
  name: 'OnboardingGoal',
  components: {
    PageContainer,
  },
  props: {
  },
  emits: [
  ],
  data() {
    return {
      goals: Object.entries(Goal.map).map(([key, value]) => {
        return {
          key: key,
          ...value,
          selected: false,
        }
      }),
    }
  },
  beforeMount() {
    this.loadGoal()
  },
  watch: {
  },
  methods: {
    loadGoal() {
      const selected = this.userStore.user.goal ?? null
      this.selectGoal(Goal.indexToKey(selected))
    },
    selectGoal(key) {
      // Update selected goal to `selected = true` and update all other goals
      // to `selected = false`.
      this.goals = this.goals.map(g => {
        if (g.key === key) {
          g.selected = true
          return g
        } else {
          g.selected = false
          return g
        }
      })
    },
    async goToNext() {
      const goalType = Goal.keyToIndex(this.selectedGoal.key)
      await this.userStore.user.updateGoal(goalType)
      this.$router.push('/onboarding/purpose')
    },
  },
  computed: {
    hasSelectedGoal() {
      return this.goals.some(g => {
        return g.selected === true
      })
    },
    selectedGoal() {
      return this.goals.find(g => {
        return g.selected === true
      })
    },
    ...mapStores(useUserStore),
  }
}
</script>